import {
  createRouter,
  createWebHistory
} from 'vue-router'

import login from '../components/login/login.vue';
import list from '../components/list/list.vue';
import classList from '../components/class-list/class-list.vue';
import warning from '../components/warning/warning.vue';
import personal from '../components/personal-certer/personal-certer.vue';

const routes = [
  { path: '/', component: login },
  { path: '/classList', component: classList },
  { path: '/list/:classId', component: list },
  { path: '/warning', component: warning },
  { path: '/personal', component: personal }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router